export const WAITLIST_SUBSCRIBE_CLICKED = 'WAITLIST_SUBSCRIBE_CLICKED';
export const WAITLIST_TOGGLE_FORM_VISIBILITY = 'WAITLIST_TOGGLE_FORM_VISIBILITY';

export const WAITLIST_SUBSCRIBE = 'WAITLIST_SUBSCRIBE';
export const WAITLIST_SUBSCRIBE_PENDING = `${WAITLIST_SUBSCRIBE}_PENDING`;
export const WAITLIST_SUBSCRIBE_FULFILLED = `${WAITLIST_SUBSCRIBE}_FULFILLED`;
export const WAITLIST_SUBSCRIBE_REJECTED = `${WAITLIST_SUBSCRIBE}_REJECTED`;

export const subscribeToWaitlistClicked = (sliceId, data) => ({
  meta: {
    sliceId,
  },
  type: WAITLIST_SUBSCRIBE_CLICKED,
  payload: data,
});

export const subscribeToWaitlistActionCreator = (sliceId, promise) => ({
  meta: {
    sliceId,
  },
  type: WAITLIST_SUBSCRIBE,
  payload: promise,
});

export const toogleWaitlistFormVisibility = sliceId => ({
  meta: {
    sliceId,
  },
  type: WAITLIST_TOGGLE_FORM_VISIBILITY,
});
